const ALLOWED_TAGS = new Set(['SPAN', 'BR', 'EM']);
const ALLOWED_CLASSES = new Set(['home-aliados__title-accent']);

const ALIADOS_MARKUP_PATTERN = /<(span|br|em)\b/i;

export function escapeAliadosHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function containsAliadosMarkup(text: string): boolean {
  return ALIADOS_MARKUP_PATTERN.test(text);
}

/** Sanitiza HTML permitido para el título administrable de aliados. */
export function sanitizeAliadosHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (!containsAliadosMarkup(trimmed)) {
    return escapeAliadosHtml(trimmed);
  }

  if (typeof DOMParser === 'undefined') {
    return escapeAliadosHtml(trimmed);
  }

  const doc = new DOMParser().parseFromString(trimmed, 'text/html');
  return serializeAllowedAliadosNodes(doc.body).trim();
}

function serializeAllowedAliadosNodes(parent: ParentNode): string {
  let html = '';

  parent.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      html += escapeAliadosHtml(node.textContent ?? '');
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const element = node as HTMLElement;
    const tag = element.tagName;

    if (!ALLOWED_TAGS.has(tag)) {
      html += serializeAllowedAliadosNodes(element);
      return;
    }

    if (tag === 'BR') {
      html += '<br>';
      return;
    }

    const classes = [...element.classList].filter((className) =>
      ALLOWED_CLASSES.has(className)
    );
    const classAttr = classes.length ? ` class="${classes.join(' ')}"` : '';
    const tagName = tag.toLowerCase();

    html += `<${tagName}${classAttr}>${serializeAllowedAliadosNodes(element)}</${tagName}>`;
  });

  return html;
}

export function prepareAliadosTitleHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (containsAliadosMarkup(trimmed)) {
    return sanitizeAliadosHtml(trimmed);
  }

  return escapeAliadosHtml(trimmed);
}
